import { motion } from 'framer-motion';
import { HiHeart } from 'react-icons/hi';
import { FaLinkedin } from 'react-icons/fa';

interface SocialLink {
  icon: React.ComponentType<{ size: number }>;
  name: string;
  url: string;
  color: string;
}

const Footer = () => {
  const socialLinks: SocialLink[] = [
    {
      icon: FaLinkedin,
      name: 'LinkedIn',
      url: 'https://au.linkedin.com/in/balaji-iyer-2904',
      color: 'hover:text-blue-600'
    }
  ];

  return (
    <footer className="bg-dark-900 text-white py-12">
      <div className="container-custom">
        <div className="text-center">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-6"
          >
            <h3 className="text-2xl font-bold gradient-text">Balaji Iyer</h3>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="flex justify-center space-x-6 mb-8"
          >
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className={`text-gray-400 transition-colors duration-200 ${social.color}`}
              >
                <social.icon size={24} />
              </motion.a>
            ))}
          </motion.div>

          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-gray-400"
          >
            <p className="flex items-center justify-center gap-2">
              © {new Date().getFullYear()} Balaji Iyer. Made with 
              <HiHeart className="text-red-500" size={16} /> 
              and lots of coffee.
            </p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 